import { createFileRoute } from '@tanstack/react-router';
import { redirectToSegmentDefaultTab } from '@/pages/workspaces/activity-logs/routing';

// Index → default tab (mirrors Ember `logs.index`). Segment canonicalization happens in the
// tab view, so this stays static and race-free.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/activity_logs/')({
  beforeLoad: ({ params }) => redirectToSegmentDefaultTab('activity_logs', params),
});
